import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex items-center gap-2"
};
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_5 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_6 = {
  class: "col-span-2"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "col-span-2"
};
const _hoisted_9 = {
  key: 2,
  class: "col-span-2"
};
const _hoisted_10 = {
  class: "col-span-2"
};
const _hoisted_11 = {
  key: 0,
  class: "form-helper"
};
const _hoisted_12 = {
  class: "col-span-2"
};
const _hoisted_13 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-between gap-3 shrink-0"
};
const _hoisted_14 = {
  class: "flex items-center gap-2"
};
const _hoisted_15 = {
  class: "flex items-center gap-3"
};
const _hoisted_16 = ["disabled"];
const _hoisted_17 = {
  class: "p-6 space-y-4"
};
const _hoisted_18 = ["disabled"];
const _hoisted_19 = {
  class: "p-6"
};
const _hoisted_20 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_21 = {
  key: 1,
  class: "divide-y divide-slate-100"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "min-w-0"
};
const _hoisted_24 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_25 = {
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_26 = {
  class: "p-6"
};
const _hoisted_27 = {
  key: 0,
  class: "py-8 text-center text-sm text-slate-400"
};
const _hoisted_28 = {
  key: 1,
  class: "divide-y divide-slate-100"
};
const _hoisted_29 = {
  class: "min-w-0"
};
const _hoisted_30 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_31 = {
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_32 = ["onClick"];
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { meetingApi } from '@/api/meeting';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
export default {
  __name: 'MeetingFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    meeting: {
      type: Object,
      default: null
    } // null=新建，否则编辑回填
  },
  emits: ['close', 'saved'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const userStore = useUserStore();
    const isEdit = computed(() => !!props.meeting?.id);
    const form = reactive({
      title: '',
      meetingType: 'INTERNAL',
      meetingMode: 'OFFLINE',
      startTime: '',
      endTime: '',
      location: '',
      onlineLink: '',
      hostId: null,
      attendeeUserIds: [],
      customerId: null,
      reminderBefore: 15,
      remark: ''
    });
    const saving = ref(false);
    // 编辑模式脏标记：用户未触碰提醒字段时，payload 不带 reminderBefore（后端 null=保留日程原值；
    // MeetingDTO 不含 reminderBefore，无法回填原值，只能靠脏标记避免每次编辑把日程提醒重置为 15）
    const reminderTouched = ref(false);

    // ===== 会议模板 =====
    // meetingMode 枚举无 desc 字段，前端自行映射中文
    const MEETING_MODE_TEXT = {
      OFFLINE: '线下',
      ONLINE: '线上',
      HYBRID: '混合'
    };
    const meetingModeText = mode => MEETING_MODE_TEXT[mode] || mode || '-';
    const templateList = ref([]);
    const templatePickerVisible = ref(false);
    const saveTemplateVisible = ref(false);
    const manageTemplateVisible = ref(false);
    const templateSaving = ref(false);
    const templateForm = reactive({
      name: '',
      durationMinutes: null
    });

    // 加载我的模板列表（弹窗打开时加载一次，存为/删除模板后刷新）
    const loadTemplates = async () => {
      try {
        templateList.value = (await meetingApi.getMeetingTemplateList()) || [];
      } catch (error) {
        console.error('加载会议模板失败', error);
      }
    };

    // 'YYYY-MM-DD HH:mm:ss' 加分钟数后同格式返回（new Date 对横杠格式兼容性差，统一转斜杠解析）
    const addMinutes = (timeStr, minutes) => {
      const date = new Date(String(timeStr).replace(/-/g, '/'));
      if (isNaN(date.getTime())) return '';
      const end = new Date(date.getTime() + minutes * 60000);
      const pad = n => String(n).padStart(2, '0');
      return `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())} ${pad(end.getHours())}:${pad(end.getMinutes())}:${pad(end.getSeconds())}`;
    };

    // 应用模板回填并关闭选择弹窗：主题/开始时间不回填（用户自己填）；
    // 有默认时长且已选开始时间时自动推算结束时间
    const handleTemplateApply = t => {
      if (!t) return;
      form.meetingType = t.meetingType || 'INTERNAL';
      form.meetingMode = t.meetingMode || 'OFFLINE';
      form.location = t.location || '';
      form.onlineLink = t.onlineLink || '';
      form.attendeeUserIds = Array.isArray(t.attendeeUserIds) ? [...t.attendeeUserIds] : [];
      if (t.durationMinutes && form.startTime) {
        form.endTime = addMinutes(form.startTime, t.durationMinutes);
      }
      templatePickerVisible.value = false;
      ElMessage.success(`已应用模板「${t.name}」`);
    };

    // 打开存为模板弹窗：名称回显建议值（当前主题），默认时长取起止时间差值（分钟，可空）
    const openSaveTemplate = () => {
      templateForm.name = form.title || '';
      templateForm.durationMinutes = null;
      if (form.startTime && form.endTime) {
        const start = new Date(String(form.startTime).replace(/-/g, '/'));
        const end = new Date(String(form.endTime).replace(/-/g, '/'));
        const diff = Math.round((end.getTime() - start.getTime()) / 60000);
        if (diff > 0) templateForm.durationMinutes = diff;
      }
      saveTemplateVisible.value = true;
    };
    const handleSaveTemplate = async () => {
      if (!templateForm.name?.trim()) {
        ElMessage.warning('请输入模板名称');
        return;
      }
      templateSaving.value = true;
      try {
        await meetingApi.saveMeetingTemplate({
          name: templateForm.name.trim(),
          meetingType: form.meetingType,
          meetingMode: form.meetingMode,
          location: form.location || '',
          onlineLink: form.onlineLink || '',
          durationMinutes: templateForm.durationMinutes ?? null,
          attendeeUserIds: form.attendeeUserIds
        });
        ElMessage.success('模板已保存');
        saveTemplateVisible.value = false;
        loadTemplates();
      } catch (error) {
        // 错误已由拦截器提示
        console.error('保存会议模板失败:', error);
      } finally {
        templateSaving.value = false;
      }
    };
    const handleDeleteTemplate = async t => {
      try {
        await ElMessageBox.confirm(`确定要删除模板「${t.name}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.deleteMeetingTemplate(t.id);
        ElMessage.success('模板已删除');
        loadTemplates();
      } catch (error) {
        if (error !== 'cancel') {
          // 错误已由拦截器提示
          console.error('删除会议模板失败:', error);
        }
      }
    };

    // 监听弹窗打开，初始化/回填表单
    watch(() => [props.visible, props.meeting], ([visible]) => {
      if (!visible) return;
      reminderTouched.value = false;
      // 模板列表每次打开加载一次（新建用于「从模板选择」，编辑用于底栏「管理模板」）
      loadTemplates();
      if (props.meeting?.id) {
        const m = props.meeting;
        Object.assign(form, {
          title: m.title || '',
          meetingType: m.meetingType || 'INTERNAL',
          meetingMode: m.meetingMode || 'OFFLINE',
          startTime: m.startTime || '',
          endTime: m.endTime || '',
          location: m.location || '',
          onlineLink: m.onlineLink || '',
          hostId: m.hostId ?? null,
          attendeeUserIds: Array.isArray(m.attendeeUserIds) ? [...m.attendeeUserIds] : [],
          customerId: m.customerId ?? null,
          reminderBefore: 15,
          remark: m.remark || ''
        });
      } else {
        Object.assign(form, {
          title: '',
          meetingType: 'INTERNAL',
          meetingMode: 'OFFLINE',
          startTime: '',
          endTime: '',
          location: '',
          onlineLink: '',
          // 新建会议主持人默认为当前用户（后端不传时默认=组织者，此处显式带出保持一致）
          hostId: userStore.userInfo?.userId ?? null,
          attendeeUserIds: [],
          customerId: null,
          reminderBefore: 15,
          remark: ''
        });
      }
    });
    const handleSubmit = async () => {
      if (!form.title?.trim()) {
        ElMessage.warning('请输入会议主题');
        return;
      }
      if (!form.startTime || !form.endTime) {
        ElMessage.warning('请选择会议起止时间');
        return;
      }
      if (form.endTime <= form.startTime) {
        ElMessage.warning('结束时间必须晚于开始时间');
        return;
      }
      // 按会议方式校验必填（与后端规则一致：OFFLINE 必填地点、ONLINE 必填线上链接、HYBRID 两者必填）
      if (form.meetingMode !== 'ONLINE' && !form.location?.trim()) {
        ElMessage.warning('请输入会议地点');
        return;
      }
      if (form.meetingMode !== 'OFFLINE' && !form.onlineLink?.trim()) {
        ElMessage.warning('请输入线上会议链接');
        return;
      }
      saving.value = true;
      try {
        const payload = {
          ...form
        };
        if (payload.meetingType !== 'CUSTOMER') payload.customerId = null;
        // 按模式清理隐藏字段：创建时置 null；编辑时若原值非空则传空串让后端覆盖
        // （后端 update 语义 null=不更新、空串会更新，见 MeetingMapper 的 <if test="... != null">）
        if (payload.meetingMode === 'OFFLINE') {
          payload.onlineLink = props.meeting?.id ? props.meeting.onlineLink ? '' : null : null;
        }
        if (payload.meetingMode === 'ONLINE') {
          payload.location = props.meeting?.id ? props.meeting.location ? '' : null : null;
        }
        if (props.meeting?.id) {
          // 编辑且用户未触碰提醒字段：不传 reminderBefore，后端保留日程原值
          if (!reminderTouched.value) delete payload.reminderBefore;
          await meetingApi.updateMeeting(props.meeting.id, payload);
          ElMessage.success('会议已更新');
        } else {
          await meetingApi.createMeeting(payload);
          ElMessage.success('会议已创建');
        }
        emit('saved');
      } catch (error) {
        // 错误已由拦截器提示
        console.error('保存会议失败:', error);
      } finally {
        saving.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input_number = _resolveComponent("el-input-number");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.visible,
          size: "xl",
          onClose: _cache[17] || (_cache[17] = $event => emit('close'))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(isEdit.value ? '编辑会议' : '新建会议'), 1), _createElementVNode("div", _hoisted_3, [!isEdit.value ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-secondary h-9",
            onClick: _cache[0] || (_cache[0] = $event => templatePickerVisible.value = true)
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
          })], -1), _createTextVNode(" 从模板选择 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[1] || (_cache[1] = $event => emit('close'))
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 会议主题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.title = $event),
            type: "text",
            placeholder: "请输入会议主题",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.title]])]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 会议类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.meetingType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.meetingType = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "内部会议",
              value: "INTERNAL"
            }), _createVNode(_component_el_option, {
              label: "客户相关会议",
              value: "CUSTOMER"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 会议方式 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.meetingMode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.meetingMode = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "线下",
              value: "OFFLINE"
            }), _createVNode(_component_el_option, {
              label: "线上",
              value: "ONLINE"
            }), _createVNode(_component_el_option, {
              label: "混合",
              value: "HYBRID"
            })]),
            _: 1
          }, 8, ["modelValue"])]), form.meetingType === 'CUSTOMER' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "form-label"
          }, "关联客户", -1)), _createVNode(CustomerSelector, {
            modelValue: form.customerId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.customerId = $event),
            placeholder: "搜索并选择客户",
            class: "w-full"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 开始时间 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: form.startTime,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.startTime = $event),
            type: "datetime",
            placeholder: "请选择开始时间",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            class: "form-date w-full"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 结束时间 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: form.endTime,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.endTime = $event),
            type: "datetime",
            placeholder: "请选择结束时间",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            class: "form-date w-full"
          }, null, 8, ["modelValue"])]), form.meetingMode !== 'ONLINE' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 会议地点 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.location = $event),
            type: "text",
            placeholder: "请输入线下会议地点",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.location]])])) : _createCommentVNode("", true), form.meetingMode !== 'OFFLINE' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 线上会议链接 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.onlineLink = $event),
            type: "text",
            placeholder: "https://...",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.onlineLink]])])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "form-label"
          }, "主持人", -1)), _createVNode(UserSelector, {
            modelValue: form.hostId,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.hostId = $event),
            placeholder: "默认为自己（组织者）"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_cache[35] || (_cache[35] = _createElementVNode("label", {
            class: "form-label"
          }, "参会人", -1)), _createVNode(UserSelector, {
            modelValue: form.attendeeUserIds,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.attendeeUserIds = $event),
            multiple: true,
            placeholder: "请选择参会人"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("label", {
            class: "form-label"
          }, "提前提醒（分钟）", -1)), _createVNode(_component_el_input_number, {
            modelValue: form.reminderBefore,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.reminderBefore = $event),
            min: 0,
            max: 1440,
            class: "form-number w-full",
            "controls-position": "right",
            onChange: _cache[13] || (_cache[13] = $event => reminderTouched.value = true)
          }, null, 8, ["modelValue"]), isEdit.value ? (_openBlock(), _createElementBlock("p", _hoisted_11, "不修改则保留原提醒设置")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_cache[37] || (_cache[37] = _createElementVNode("label", {
            class: "form-label"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.remark = $event),
            rows: "3",
            placeholder: "请输入备注信息",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.remark]])])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[15] || (_cache[15] = $event => manageTemplateVisible.value = true)
          }, " 管理模板 "), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: openSaveTemplate
          }, " 存为模板 ")]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[16] || (_cache[16] = $event => emit('close'))
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: saving.value,
            onClick: handleSubmit
          }, _toDisplayString(saving.value ? '保存中...' : '保存'), 9, _hoisted_16)])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: saveTemplateVisible.value,
          title: "存为模板",
          size: "sm",
          "z-index": 60,
          onClose: _cache[21] || (_cache[21] = $event => saveTemplateVisible.value = false)
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[20] || (_cache[20] = $event => saveTemplateVisible.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: templateSaving.value,
            onClick: handleSaveTemplate
          }, _toDisplayString(templateSaving.value ? '保存中...' : '保存'), 9, _hoisted_18)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, [_cache[38] || (_cache[38] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 模板名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => templateForm.name = $event),
            type: "text",
            placeholder: "请输入模板名称",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, templateForm.name]])]), _createElementVNode("div", null, [_cache[39] || (_cache[39] = _createElementVNode("label", {
            class: "form-label"
          }, "默认时长（分钟）", -1)), _createVNode(_component_el_input_number, {
            modelValue: templateForm.durationMinutes,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => templateForm.durationMinutes = $event),
            min: 1,
            max: 1440,
            placeholder: "可空",
            class: "form-number w-full",
            "controls-position": "right"
          }, null, 8, ["modelValue"])])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: templatePickerVisible.value,
          title: "从模板选择",
          size: "md",
          "z-index": 60,
          onClose: _cache[22] || (_cache[22] = $event => templatePickerVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [templateList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 暂无模板，可在填好表单后点击底部「存为模板」 ")) : (_openBlock(), _createElementBlock("ul", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, t => {
            return _openBlock(), _createElementBlock("li", {
              key: t.id,
              class: "py-3 px-3 -mx-3 flex items-center justify-between gap-3 rounded-lg cursor-pointer hover:bg-slate-50 transition-colors",
              onClick: $event => handleTemplateApply(t)
            }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("p", _hoisted_24, _toDisplayString(t.name), 1), _createElementVNode("p", _hoisted_25, [_createTextVNode(_toDisplayString(meetingModeText(t.meetingMode)) + " · 参会 " + _toDisplayString(t.attendeeUserIds?.length || 0) + " 人", 1), t.durationMinutes ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(" · 默认时长 " + _toDisplayString(t.durationMinutes) + " 分钟", 1)], 64)) : _createCommentVNode("", true)])]), _cache[40] || (_cache[40] = _createElementVNode("span", {
              class: "text-sm text-primary-600 shrink-0"
            }, "使用", -1))], 8, _hoisted_22);
          }), 128))]))])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: manageTemplateVisible.value,
          title: "管理模板",
          size: "md",
          "z-index": 60,
          onClose: _cache[23] || (_cache[23] = $event => manageTemplateVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [templateList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 暂无模板 ")) : (_openBlock(), _createElementBlock("ul", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, t => {
            return _openBlock(), _createElementBlock("li", {
              key: t.id,
              class: "py-3 flex items-center justify-between gap-3"
            }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("p", _hoisted_30, _toDisplayString(t.name), 1), _createElementVNode("p", _hoisted_31, [_createTextVNode(_toDisplayString(meetingModeText(t.meetingMode)) + " · 参会 " + _toDisplayString(t.attendeeUserIds?.length || 0) + " 人", 1), t.durationMinutes ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(" · 默认时长 " + _toDisplayString(t.durationMinutes) + " 分钟", 1)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("button", {
              type: "button",
              class: "btn-secondary shrink-0",
              onClick: $event => handleDeleteTemplate(t)
            }, " 删除 ", 8, _hoisted_32)]);
          }), 128))]))])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};